import { Outlet } from 'react-router-dom';
import { BeneficiariesFormProvider } from 'contexts/beneficiaries/context';
import GreetingSection from 'components/navbar/GreetingSection';
import { useTranslation } from 'react-i18next';
const { useBreakpoint } = Grid;
const { Option } = Select;
import { Select, Grid } from 'antd';
import { useEffect, useState } from 'react';
import { PolicyDropDown } from 'all-in-one-shared-api/dist/apis/policy/usePolicyDropDown';
import { usePolicyDropDown } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { isLocaleEnglish } from 'utils/languageUtils';
import { useNavigate, useLocation } from 'react-router-dom';
import './beneficiaries.less';
import { useBeneficiaries } from 'contexts/beneficiaries/context';

const BeneficiariesContent = () => {
  const { t, i18n } = useTranslation();
  const { lg } = useBreakpoint();
  const { token } = useKeycloakReady();
  const isEnglish = isLocaleEnglish(i18n.language);
  // const useCustomNavigation = () => {
  //   const navigate = useNavigate();
  //   return useCallback(navigate, [navigate]);
  // };
  const location = useLocation();
  const { policyNC, setpolicyNC, setCompanyCodeNc } = useBeneficiaries();
  const navigate = useNavigate();
  const {
    policyNumber: policyNo,
    companyCode: companyNo,
    key,
  } = (location.state as { policyNumber?: string; companyCode?: string; key?: string }) ?? {};

  const [selectItem, setSelectItem] = useState<PolicyDropDown>();
  const { shouldFetch: shouldFecthDrop, data: dropData } = usePolicyDropDown('usePolicyDropDown', token ?? '');
  const changeOptions = (value: string) => {
    setpolicyNC(value);
    setSelectItem(() => dropData?.filter((item) => item.policyNumber === value)[0]);
  };
  useEffect(() => {
    if (policyNo && companyNo) {
      setpolicyNC(policyNo);
      setCompanyCodeNc(companyNo);
    }
  }, [policyNo, companyNo, setpolicyNC, setCompanyCodeNc]);
  useEffect(() => {
    if (selectItem) {
      navigate('/LIBenefiaries', {
        state: {
          policyNo: policyNC,
          editflag: false,
          // selectItem,
        },
        replace: location.pathname === '/LIBenefiaries' ? true : false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectItem]);
  useEffect(() => {
    console.log('MOUNT Beneficiaries');
    return () => console.log('UNMOUNT Beneficiaries');
  }, []);
  useEffect(() => {
    shouldFecthDrop(true);
  }, [shouldFecthDrop]);
  useEffect(() => {
    if (!policyNC)
      navigate('/LIBenefiaries', {
        state: {
          policyNo: '',
          editflag: false,
        },
        replace: true,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policyNC]);
  return (
    <>
      <GreetingSection pageName={t('life.policies.ChangeBeneficiaries')} showicon={false} />
      {!location.pathname.includes('LifeBeneficiariesOtpVerificationPage') && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            top: lg ? '-18px' : '-12px',
            position: 'relative',
          }}
          className="top-select-b"
        >
          <Select
            onChange={changeOptions}
            disabled={!dropData || dropData.length === 0}
            className="policySelect"
            popupClassName="slectop-beneficiaries"
            placeholder={t('life.policies.selectHolder')}
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
              width: '640px',
            }}
            value={policyNC ? policyNC : null}
          >
            {dropData?.map((item) => (
              <Option
                value={item.policyNumber}
                key={item.policyNumber}
                label={isEnglish ? item.productName : item.productNameTC}
              >
                <div style={{ display: 'grid' }}>
                  <span className="black-font">{isEnglish ? item.productName : item.productNameTC}</span>
                  <span className="grey-font">
                    {t('life.policies.policyNo')}
                    {item.policyNumber}
                  </span>
                </div>
              </Option>
            ))}
          </Select>
        </div>
      )}
      <Outlet context={{ selectItem, dropData }} key={key} />
    </>
  );
};

const Beneficiaries = () => {
  return (
    <BeneficiariesFormProvider>
      {/* <GreetingSection pageName={t('life.policies.ChangeBeneficiaries')} showicon={false} />
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          top: lg ? '-18px' : '-12px',
          position: 'relative',
        }}
        className="top-select-b"
      >
        <Select
          onChange={changeOptions}
          className="policySelect"
          popupClassName="slectop-beneficiaries"
          placeholder={t('life.policies.selectHolder')}
          value={policyNumber || null}
          style={{
            fontSize: '20px',
            fontFamily: 'Roboto400',
            marginBottom: '10px',
            padding: '4px 0',
            width: '640px',
          }}
        >
          {dropData?.map((item) => (
            <Option
              value={item.policyNumber}
              key={item.policyNumber}
              label={isEnglish ? item.productName : item.productNameTC}
            >
              <div style={{ display: 'grid' }}>
                <span className="black-font">{isEnglish ? item.productName : item.productNameTC}</span>
                <span className="grey-font">
                  {t('life.policies.policyNo')}
                  {item.policyNumber}
                </span>
              </div>
            </Option>
          ))}
        </Select>
      </div>
      <Outlet /> */}
      <BeneficiariesContent></BeneficiariesContent>
    </BeneficiariesFormProvider>
  );
};

export default Beneficiaries;
